import api from './index'
import { axios } from '@/utils/request'

export function addLayer(parameter) {
  return axios({
    url: '/gis/gisLayer/add',
    method: 'post',
    data: parameter
  })
}

export function getLayerGraph(id) {
  return axios({
    url: '/gis/gisLayer/queryGisGraphByMainId?id=' + id,
    method: 'get'
  })
}

export function getLayer(id) {
  return axios({
    url: '/gis/gisLayer/queryById?id=' + id,
    method: 'get'
  })
}

export function getAllLayer() {
  return axios({
    url: '/gis/gisLayer/list',
    method: 'get'
  })
}

export function updateLayer(parameter) {
  return axios({
    url: '/gis/gisLayer/edit',
    method: 'put',
    data: parameter
  })
}

export function addTopo(parameter) {
  return axios({
    url: '/topo/topoGraph/add',
    method: 'post',
    data: parameter
  })
}

export function getTopoGraph(id) {
  if (id) {
    return axios({
      url: '/topo/topoGraph/queryById?id=' + id,
      method: 'get'
    })
  } else {
    return axios({
      url: '/topo/topoGraph/queryById',
      method: 'get'
    })
  }
}

export function deleteTopoGraph(id) {
  return axios({
    url: '/topo/topoGraph/delete?id=' + id,
    method: 'delete'
  })
}

export function getALLTopoGraph() {
  return axios({
    url: '/topo/topoGraph/list',
    method: 'get'
  })
}
export function updateTopoGraph(parameter) {
  return axios({
    url: '/topo/topoGraph/edit',
    method: 'put',
    data: parameter
  })
}
export function copyTopoGraph(parameter) {
  return axios({
    url: '/topo/topoGraph/copy',
    method: 'post',
    data: parameter
  })
}

export function getIotPoints(parameter) {
  return axios({
    url: '/monitor/iotModelPoints/list',
    method: 'get',
    params: parameter
  })
}

export function addCustomItem(parameter) {
  return axios({
    url: '/topo/topoItem/add',
    method: 'post',
    data: parameter
  })
}

export function getCustomItem(id) {
  if (id) {
    return axios({
      url: '/topo/topoItem/queryById?id=' + id,
      method: 'get'
    })
  }
}

export function deleteCustomItem(id) {
  return axios({
    url: '/topo/topoItem/delete?id=' + id,
    method: 'delete'
  })
}

export function getALLCustomItem() {
  return axios({
    url: '/topo/topoItem/list',
    method: 'get'
  })
}

export function getEquipmentType(parameter) {
  let queryString = []
  if (parameter.pageNo) {
    queryString.push('pageNo=' + parameter.pageNo)
  }
  if (parameter.pageSize) {
    queryString.push('pageSize=' + parameter.pageSize)
  }
  return axios({
    url: '/device/devClass/selectDropList?' + queryString.join('&'),
    method: 'get'
  })
}

export function getEquipmentList(parameter) {
  return axios({
    url: '/device/devList/list',
    method: 'get',
    params: parameter
  })
}

//获取监测站列表
export function getStationList(parameter) {
  let queryString = []
  if (parameter.pageNo) {
    queryString.push('pageNo=' + parameter.pageNo)
  }
  if (parameter.pageSize) {
    queryString.push('pageSize=' + parameter.pageSize)
  }
  if (parameter.staName) {
    queryString.push('staName=' + parameter.staName)
  }
  if (queryString.length > 0) {
    return axios({
      url: '/device/usStation/list?' + queryString.join('&'),
      method: 'get'
    })
  } else {
    return axios({
      url: '/device/usStation/list',
      method: 'get'
    })
  }
}

export function getStationById(id) {
  return axios({
    url: '/device/usStation/queryById?id=' + id,
    method: 'get'
  })
}

//获取水厂列表
export function getSewegePlantList(parameter) {
  let queryString = []
  if (parameter.pageNo) {
    queryString.push('pageNo=' + parameter.pageNo)
  }
  if (parameter.pageSize) {
    queryString.push('pageSize=' + parameter.pageSize)
  }
  if (parameter.plName) {
    queryString.push('plName=' + parameter.plName)
  }
  if (queryString.length > 0) {
    return axios({
      url: '/device/sewegePlantList/list?' + queryString.join('&'),
      method: 'get'
    })
  } else {
    return axios({
      url: '/device/sewegePlantList/list',
      method: 'get'
    })
  }
}

export function getSewegePlantById(id) {
  return axios({
    url: '/device/sewegePlantList/queryById?id=' + id,
    method: 'get'
  })
}

export function getSewagePlantInoutConfById() {
  return axios({
    url: '/plant/dashboard/flow',
    method: 'get'
  })
}

//获取告警信息
export function getIotAlert(id) {
  if (id) {
    return axios({
      url: '/alert/iotAlert/getIotAlertPlantStatistics?isRecovery=0&disposal=0&usStation=' + id,
      method: 'get'
    })
  } else {
    return axios({
      url: '/alert/iotAlert/getIotAlertPlantStatistics?isRecovery=0&disposal=0',
      method: 'get'
    })
  }
}
